var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('span',{directives:[{name:"tippy",rawName:"v-tippy",value:(_vm.tippyOptions),expression:"tippyOptions"}],attrs:{"content":_vm.content}},[_vm._t("default")],2):(_vm.force)?_c('span',[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }